import React from "react";
import { useNavigate } from "react-router-dom";

export default function SettingsPage() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 900 }}>
      <div style={{ background: "#fff", borderRadius: 16, padding: 24, boxShadow: "0 4px 18px rgba(0,0,0,0.06)" }}>
        <h3 style={{ margin: 0, color: "#8b1634" }}>Settings</h3>
        <p style={{ marginTop: 10, color: "#64748b" }}>
          Configure administrative preferences and system options from this section.
        </p>
        <div style={{ marginTop: 22, border: "1px solid #e2e8f0", borderRadius: 14, padding: 16 }}>
          <div style={{ fontWeight: 700, color: "#1f2937" }}>General Settings</div>
          <div style={{ fontSize: 14, color: "#64748b", marginTop: 6 }}>
            Feature visibility controls are available directly in the top header for quick access.
          </div>
        </div>
        <div style={{ marginTop: 16, border: "1px solid #e2e8f0", borderRadius: 14, padding: 16 }}>
          <div style={{ fontWeight: 700, color: "#1f2937" }}>Director</div>
          <div style={{ fontSize: 14, color: "#64748b", marginTop: 6 }}>
            Add and manage TTSL directors (name, email, phone number) used for administrative contact details.
          </div>
          <button
            type="button"
            onClick={() => navigate("/admin/directors")}
            style={{
              marginTop: 10,
              background: "#8b1634",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              height: 36,
              padding: "0 14px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Open Director
          </button>
        </div>
        <div style={{ marginTop: 16, border: "1px solid #e2e8f0", borderRadius: 14, padding: 16 }}>
          <div style={{ fontWeight: 700, color: "#1f2937" }}>Secret Key Manager</div>
          <div style={{ fontSize: 14, color: "#64748b", marginTop: 6 }}>
            Create or copy the current import encryption key. Changes apply immediately for authorised administrators.
          </div>
          <button
            type="button"
            onClick={() => navigate("/admin/secret-key")}
            style={{
              marginTop: 10,
              background: "#8b1634",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              height: 36,
              padding: "0 14px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Open Secret Key Manager
          </button>
        </div>
      </div>
    </div>
  );
}
